import type { IconSvgObject } from './types';

const CheckUnread02Icon: IconSvgObject = [
  ["path", { d: "M2.5 13.5C2.5 13.5 4.5 14 6 17C6 17 6.28485 16.5192 6.82133 15.7526M16.5 6C14.9915 6.75423 13.4376 8.05457 12.0029 9.50285", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M7.5 13.5C7.5 13.5 9.5 14 11 17C11 17 11.7152 15.8948 12.8641 14.3641M21.5 6C19.1047 7.19763 16.5947 9.7722 14.6296 12.1296", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M3.5 5L17.5 19", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default CheckUnread02Icon;
